import { Resources } from 'constants/resources';

import { AxiosError, AxiosResponse } from 'axios';
import { axiosMultipart } from 'config/axios';

export const sendLogo = async (file: FormData): Promise<AxiosResponse> => {
  return axiosMultipart
    .post(Resources.MethodLogos, file)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};

export const editLogo = async (id: string, file: FormData): Promise<AxiosResponse> => {
  return axiosMultipart
    .post(`${Resources.MethodLogos}/${id}`, file)
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
};
